<div class="isi" [ngClass]="[scrollable ? 'scrollable' : '', medicine]">
    <ng-container *ngFor="let el of data?.copy">
        <div [outerHTML]="handleHtml(el)"></div>
    </ng-container>
</div>
